"use client";

import type { FieldPath, FieldValues } from "react-hook-form";
import { createSafeContext } from "@/common/helpers/react";

export interface FormFieldContextValue<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  name: TName;
}

export const [FormFieldContext, useFormFieldContext] = createSafeContext<FormFieldContextValue>(
  "useFormField should be used within <FormField>",
);
